module.exports = __webpack_public_path__ + "static/media/sliders-h-square.9cb5a621.svg";